import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { useState, useEffect } from "react";
import NavBar from './components/NavBar';
import List from './components/List';
import New from './components/New';
import Page404 from './components/Page404';
import Profile from './components/Profile';
import InvoiceDetails from './components/Details';
import Login from './components/Login';
import Home from './components/Home';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [auth, setAuth] = useState(false);  

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuth(true);
    }    
  }, []);

  return (
    <div className="app">
    <Router>
      <div className="header">          
          <div className="logo">
            Invoice manager
          </div>          
          <NavBar auth={auth} setAuth={setAuth}/>
      </div>
      <div className="content">
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/index" element={<ProtectedRoute element={<List title='Invoices list' />} />} />          
          <Route path="/new" element={<ProtectedRoute element={<New />} />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/invoices/:id" element={<InvoiceDetails />} />
          <Route path="/login" element={<Login setAuth={setAuth}/>} />
          <Route path="*" element={ <Page404 />} />
        </Routes>
      </div>
      <div className="footer">
          <p className="copyright">
            © 2025 Plusat Consulting srl. All rights reserved.
          </p>
          <div className="contact-text">
            Contact info:
            <br />
            mail: office@plusat.be
            <br />
            phone: +32.470.617.042
          </div>
      </div>
    </Router>
    </div>
  );
}

export default App;
      